const ShareholdersIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66101 9.44849H15.6455L22.7578 16.6073C30.941 2.04041 8.12945 -5.00827 5.66101 9.44849ZM20.7258 18.9722C21.1335 22.3398 20.5425 23.3484 19.9358 24.384C19.4216 25.2617 18.896 26.1589 18.9575 28.5283H12.297C12.297 26.3585 11.4532 25.569 10.5777 24.7499C9.5524 23.7906 8.48371 22.7907 8.67608 19.4857V15.4043C8.67608 14.8274 9.14831 14.3598 9.72518 14.3598C10.302 14.3598 10.7743 14.8274 10.7743 15.4043V19.4857C13.7586 21.0286 16.7478 20.9274 20.7258 18.9722ZM5.48463 11.3431C5.48463 11.3431 11.872 11.3482 14.9995 11.3431L21.1597 17.5032L20.4718 17.8413C18.5649 18.7786 16.9656 19.236 15.5347 19.304C14.3178 19.3618 13.1773 19.1402 12.0256 18.6346V15.2108C12.0256 14.0512 11.0798 13.1218 9.93201 13.1218C8.78423 13.1218 7.83841 14.0512 7.83841 15.2108V17.1307C6.33127 15.5625 5.41055 13.5405 5.48463 11.3431Z"
        fill="black"
      />
    </svg>
  );
};

export default ShareholdersIcon;
